import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollToTop from './components/ScrollToTop';
import './styles/App.css';
import './styles/EmojiConversations.css'
import './styles/responsive.css';
import TermsOfService from './pages/terms-of-use.js';
import PrivacyPolicy from './pages/privacy-policy.js';
import HomePage from './pages/HomePage'; // Adjust the path as necessary based on your file structure
import Header from './components/Header';
import MediaKit from './pages/media-kit';
import PitchDeck from './pages/pitch-deck';
import AboutUs from './pages/about';
import CoffeeShop from './pages/coffee-shop';
import Personas from './personas/personasPage.js';
import './styles/Font.css'; 
import NotFound from './pages/NotFound';
import Faq from './pages/faq';





  
function App() {
  return (
    <Router>
      <ScrollToTop>
      <div className="App">
       
        <Routes>
          <Route path="/" element={<><Header /><HomePage /></>} />
          <Route path="/terms-of-use" element={<><Header /><TermsOfService  /></>} />
          <Route path="/privacy-policy" element={<><Header /><PrivacyPolicy  /></>} />
          <Route path="/media-kit" element={<><Header /><MediaKit /></>} />
          <Route path="/pitch-deck" element={<><Header /><PitchDeck /></>} />
          <Route path="/about" element={<><Header /><AboutUs /></>} />
          <Route path="/faq" element={<><Header /><Faq /></>} />
          <Route path="/coffee-shop" element={<><Header /><CoffeeShop /></>} />
          <Route path="/personas" element={<><Header /><Personas /></>} />
          <Route path="/personas/:slug" element={<><Header /><Personas /></>} />
          <Route path="*" element={<><Header /><NotFound /></>} />
        </Routes>
      </div>
      </ScrollToTop>
    </Router>
  );
}



export default App;